import { Table } from "@chakra-ui/react"
import * as React from "react"

export const TableRoot = React.forwardRef<HTMLTableElement, Table.RootProps>(
  function TableRoot(props, ref) {
    return <Table.Root ref={ref} {...props} />
  },
)

export const TableHeader = React.forwardRef<HTMLTableSectionElement, Table.HeaderProps>(
  function TableHeader(props, ref) {
    return <Table.Header ref={ref} {...props} />
  },
)

export const TableBody = React.forwardRef<HTMLTableSectionElement, Table.BodyProps>(
  function TableBody(props, ref) {
    return <Table.Body ref={ref} {...props} />
  },
)

export const TableRow = React.forwardRef<HTMLTableRowElement, Table.RowProps>(
  function TableRow(props, ref) {
    return <Table.Row ref={ref} {...props} />
  },
)

export const TableColumnHeader = React.forwardRef<HTMLTableCellElement, Table.ColumnHeaderProps>(
  function TableColumnHeader(props, ref) {
    return <Table.ColumnHeader ref={ref} {...props} />
  },
)

export const TableCell = React.forwardRef<HTMLTableCellElement, Table.CellProps>(
  function TableCell(props, ref) {
    return <Table.Cell ref={ref} {...props} />
  },
) 